import React from "react";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import classes from "../../../InviteCode.module.scss";
import { useTranslation } from "react-i18next";
import InviteContainer from "../InviteContainer";

const CodeInviteCard = ({
  inviteCode, // Código do convite gerado
  isCodeCopied, // Indica se o código já foi copiado
  copyToClipboardHandler, // Função para copiar o código
  isFetching, // Estado de carregamento para mostrar spinner
  fetchCodeHandler, // Função para gerar ou gerar novo código
  upgradeAlert, // Componente ou mensagem de alerta para upgrade
  hasError, // Indica se há erro para mostrar alerta
}) => {
  const { t } = useTranslation(); // Função para traduções
  
  return (
    <InviteContainer
      title={t("inviteUsers.invite_code")} // Título do card
      description={t("inviteUsers.create_a_code_for_redemption")} // Descrição do card
      value={inviteCode} // Valor do código gerado
      isCopied={isCodeCopied} // Indica se o código foi copiado
      isFetching={isFetching} // Exibe spinner se estiver carregando
      onCopy={copyToClipboardHandler} // Função executada ao copiar o código
      onGenerate={fetchCodeHandler} // Função para gerar novo código
      generateButtonText={t("global.generate_code")}
      icon={faLink}
      classes={classes}
      upgradeAlert={upgradeAlert} // Exibe alerta para upgrade, se houver
      hasError={hasError} // Indica se existe erro para mostrar alerta
    />
  );
};

export default CodeInviteCard;
